import React, { useState, useEffect } from "react";
import axios from "axios";
import { Modal, Button, Table, Form } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Portfolio = () => {
    const [portfolio, setPortfolio] = useState([]);
    const [services, setServices] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState("add");
    const [formData, setFormData] = useState({
        value: "",
        service_id: "",
        type: "",
        link: "",
        desc: "",
        id: null,
    });

    useEffect(() => {
        fetchPortfolio();
        fetchServices();
    }, []);

    const fetchPortfolio = () => {
        axios
            .get("https://api.glyphqai.com/api/get-portfolio")
            .then((response) => {
                if (response.data.status === 200) {
                    setPortfolio(response.data.portfolio);
                }
            })
            .catch((error) => console.error("Error fetching portfolio:", error));
    };

    const fetchServices = () => {
        axios
            .get("https://api.glyphqai.com/api/get-servicetype")
            .then((response) => {
                if (response.data.status === 200) {
                    setServices(response.data.service_type);
                }
            })
            .catch((error) => console.error("Error fetching services:", error));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleOpenModal = (type, portfolioItem = null) => {
        setModalType(type);
        if (type === "edit" && portfolioItem) {
            setFormData({
                value: portfolioItem.value,
                service_id: portfolioItem.service_id || "",
                type: portfolioItem.type,
                link: portfolioItem.link || "",
                desc: portfolioItem.desc || "",
                id: portfolioItem.id,
            });
        } else {
            setFormData({
                value: "",
                service_id: "",
                type: "",
                link: "",
                desc: "",
                id: null,
            });
        }
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const formPayload = new FormData();
        formPayload.append("value", formData.value);
        formPayload.append("service_id", formData.service_id);
        formPayload.append("type", formData.type);
        formPayload.append("link", formData.link);
        formPayload.append("desc", formData.desc);

        if (modalType === "add") {
            axios
                .post(
                    "https://api.glyphqai.com/api/store-portfolio",
                    formPayload,
                    {
                        headers: { "Content-Type": "multipart/form-data" },
                    }
                )
                .then(() => {
                    toast.success("Portfolio added successfully!");
                    fetchPortfolio();
                    handleCloseModal();
                })
                .catch((error) => {
                    console.error("Error storing portfolio:", error);
                    toast.error("Failed to add portfolio.");
                });
        } else if (modalType === "edit") {
            formPayload.append("_method", "PUT")

            axios
                .post(
                    `https://api.glyphqai.com/api/update-portfolio/${formData.id}`,
                    formPayload
                    )
                .then(() => {
                    toast.success("Portfolio updated successfully!");
                    fetchPortfolio(); // Refresh portfolio
                    handleCloseModal();
                })
                .catch((error) => {
                    console.error("Error updating portfolio:", error);
                    toast.error("Failed to update portfolio.");
                });
        }
    };

    const handleDelete = (id) => {
        axios
            .delete(
                `https://api.glyphqai.com/api/deleteportfolio/${id}`
            )
            .then(() => {
                setPortfolio(portfolio.filter((item) => item.id !== id));
                toast.success("Portfolio deleted successfully!");
            })
            .catch((error) => {
                console.error("Error deleting portfolio:", error);
                toast.error("Failed to delete portfolio.");
            });
    };

    return (
        <>
            <div></div>
            <div className="container">
                <div className="my-3 mt-5 d-flex justify-content-between">
                    <h2 className="font-bold display-5">Portfolio</h2>
                    <Button onClick={() => handleOpenModal("add")} className="mb-3">
                        Add Portfolio
                    </Button>
                </div>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th className="text-center">#</th>
                            <th>Video</th>
                            <th>Service</th>
                            <th>Link</th>
                            <th>Desc</th>
                            <th>Type</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {portfolio.map((item, index) => (
                            <tr key={item.id}>
                                <td className="text-center">{index + 1}</td>
                                <td>
                                    {item.type === 'video' ? (
                                        <video
                                            width="200"
                                            controls
                                            src={`https://api.glyphqai.com/uploads/portfolio/${item.value}`}
                                        >
                                        </video>
                                    ) : (
                                        <img
                                            src={`https://api.glyphqai.com/uploads/portfolio/${item.value}`}
                                            alt={`project of ${item.title}`}
                                        />
                                    )}
                                </td>
                                <td>
                                    {
                                        services.find((service) => service.id === item.service_id)
                                            ?.title
                                    }
                                </td>
                                <td>{item.link}</td>
                                <td>{item.desc}</td>
                                <td>{item.type}</td>
                                <td>
                                    <Button onClick={() => handleOpenModal("edit", item)}>
                                        Edit
                                    </Button>{" "}
                                    <Button
                                        variant="danger"
                                        onClick={() => handleDelete(item.id)}
                                    >
                                        Delete
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>

            {/* Modal for Add/Edit Portfolio */}
            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {modalType === "add" ? "Add Portfolio" : "Edit Portfolio"}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="formService" className="mt-0">
                            <Form.Label>Service</Form.Label>
                            <Form.Control
                                as="select"
                                name="service_id"
                                value={formData.service_id}
                                onChange={handleInputChange}
                                required
                            >
                                <option value="">Select a service</option>
                                {services.map((service) => (
                                    <option key={service.id} value={service.id}>
                                        {service.title}
                                    </option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group controlId="formType" className="mt-3">
                            <Form.Label>Portfolio Type</Form.Label>
                            <Form.Control
                                as="select"
                                name="type"
                                value={formData.type}
                                onChange={handleInputChange}
                                required
                            >
                                <option value="">Select portfolio type</option>
                                <option value="video">Video</option>
                                <option value="image">Image</option>
                            </Form.Control>
                        </Form.Group>
                        <Form.Group controlId="formLink" className="mt-3">
                            <Form.Label>Link</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter link"
                                name="link"
                                value={formData.link}
                                onChange={handleInputChange}
                                required
                            />
                        </Form.Group>
                        <Form.Group controlId="formDesc" className="mt-3">
                            <Form.Label>Description</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                placeholder="Enter description"
                                name="desc"
                                value={formData.desc}
                                onChange={handleInputChange}
                                required
                            />
                        </Form.Group>
                        {true &&
                            <Form.Group controlId="formValue" className="mt-3">
                                <Form.Label>File</Form.Label>
                                <Form.Control
                                    type="file"
                                    name="value"
                                    onChange={(e) =>
                                        setFormData({ ...formData, value: e.target.files[0] })
                                    }
                                    required
                                />
                            </Form.Group>
                        }
                        <Button className="mt-3" type="submit">
                            {modalType === "add" ? "Add Portfolio" : "Update Portfolio"}
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>

            <ToastContainer />
        </>
    );
};

export default Portfolio;
